import React, { memo } from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { IPortalFolder } from '@interfaces/portal/folders';

import colors from '@constants/colors';

import styles from './SelectFolderItem.module.scss';

interface IFolderTreeProps {
	folder: IPortalFolder;
	onSelect: (data: IPortalFolder) => void;
	depth?: number;
	disabledFolderId?: string;
}

const BASE_PADDING = 10;
const INDENT_STEP = 25;

const SelectFolderItem = ({
	folder,
	onSelect,
	depth = 0,
	disabledFolderId,
}: IFolderTreeProps) => {
	const {
		name: folderName,
		hasContent: folderHasContent,
	} = folder;

	const isDisabled = folder.id === disabledFolderId;

	const onFolderClick = () => {
		if (isDisabled) {
			return;
		}

		onSelect(folder);
	};

	return (
		<div
			className={styles.folderItem}
			onClick={onFolderClick}
			style={{ paddingLeft: depth ? depth * INDENT_STEP : BASE_PADDING }}
		>
			<div className={cn(styles.folderName, { [styles.disabled]: isDisabled })}>
				<div>
					{folderHasContent
						? Icons.folderIcon({ color: isDisabled ? colors.gray50 : undefined })
						: Icons.folderEmpty()
					}
				</div>
				{folderName}
			</div>
		</div>
	);
};

export default memo(SelectFolderItem);
